import { ConfigPODTypes } from './actionTypes';

const INIT_STATE = {
  configPODData: {},
  error: '',
  success: '',
  isLoading: false,
  isSaving: false,
};

const ConfigPOD = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ConfigPODTypes.GET_CONFIG_POD:
      return {
        ...state,
        isLoading: true,
      };
    case ConfigPODTypes.GET_CONFIG_POD_SUCCESS:
      return {
        ...state,
        configPODData: action.payload,
        isLoading: false,
      };
    case ConfigPODTypes.GET_CONFIG_POD_FAIL:
      return {
        ...state,
        error: action.payload,
        configPODData: {},
        isLoading: false,
      };

    case ConfigPODTypes.SAVE_CONFIG_POD:
      return {
        ...state,
        isSaving: true,
      };
    case ConfigPODTypes.SAVE_CONFIG_POD_SUCCESS:
      return {
        ...state,
        success: action.payload,
        isSaving: false,
      };
    case ConfigPODTypes.SAVE_CONFIG_POD_FAIL:
      return {
        ...state,
        error: action.payload,
        isSaving: false,
      };
    default:
      return state;
  }
};

export default ConfigPOD;
